const catalogFacetDefaults = {
  aiPowered: false,
  hasMobileApp: false,
  ossLicense: 'Proprietary',
  dataExport: 'Manual request',
  offlineMode: false,
  adSupported: false,
  tracksUserData: false,
  complianceReady: false,
  projectAge: '5+ years',
  communityActive: false,
  philosophies: []
};

const catalogMetadata = {
  notion: {
    aiPowered: true,
    dataExport: 'API + CSV',
    tracksUserData: true,
    complianceReady: true,
    communityActive: true,
    philosophies: ['sustainability', 'transparent']
  },
  obsidian: {
    pricing: 'one-time purchase',
    dataExport: 'Markdown/Local',
    offlineMode: true,
    tracksUserData: false,
    projectAge: '2-5 years',
    communityActive: true,
    philosophies: ['local-first', 'transparent']
  },
  clickup: {
    aiPowered: true,
    dataExport: 'API + CSV',
    tracksUserData: true,
    communityActive: true,
    philosophies: ['sustainability']
  },
  youtube: {
    aiPowered: true,
    dataExport: 'Manual request',
    adSupported: true,
    tracksUserData: true,
    complianceReady: false,
    communityActive: false
  },
  joplin: {
    dataExport: 'Markdown/Local',
    offlineMode: true,
    tracksUserData: false,
    communityActive: true,
    ossLicense: 'AGPL-3.0',
    philosophies: ['local-first', 'decentralised', 'transparent']
  },
  evernote: {
    aiPowered: true,
    dataExport: 'CSV only',
    tracksUserData: true,
    communityActive: false,
    philosophies: ['sustainability']
  },
  fibery: {
    aiPowered: true,
    dataExport: 'API + CSV',
    tracksUserData: false,
    projectAge: '2-5 years',
    communityActive: true,
    ossLicense: 'Business Source',
    philosophies: ['sustainability', 'transparent']
  },
  trello: {
    dataExport: 'CSV only',
    tracksUserData: true,
    communityActive: true
  },
  airtable: {
    aiPowered: true,
    dataExport: 'API + CSV',
    tracksUserData: true,
    communityActive: true,
    philosophies: ['transparent']
  },
  monday: {
    aiPowered: true,
    dataExport: 'API + CSV',
    tracksUserData: true,
    communityActive: true
  },
  google: {
    aiPowered: true,
    dataExport: 'JSON export',
    adSupported: true,
    tracksUserData: true,
    communityActive: false
  },
  gdrive: {
    aiPowered: true,
    dataExport: 'Full backup',
    offlineMode: true,
    tracksUserData: true,
    communityActive: false,
    philosophies: ['transparent']
  },
  protonmail: {
    dataExport: 'JSON export',
    tracksUserData: false,
    communityActive: true,
    philosophies: ['sustainability', 'transparent']
  },
  github: {
    aiPowered: true,
    dataExport: 'JSON export',
    hasMobileApp: true,
    tracksUserData: true,
    communityActive: true,
    philosophies: ['transparent']
  },
  gitlab: {
    isOpenSource: true,
    aiPowered: true,
    dataExport: 'API + CSV',
    tracksUserData: false,
    communityActive: true,
    ossLicense: 'MIT',
    philosophies: ['transparent', 'sustainability']
  },
  telegram: {
    dataExport: 'Full backup',
    offlineMode: true,
    tracksUserData: false,
    complianceReady: false,
    communityActive: true,
    philosophies: ['decentralised', 'transparent']
  },
  slack: {
    aiPowered: true,
    dataExport: 'API + CSV',
    tracksUserData: true,
    communityActive: true
  },
  teams: {
    aiPowered: true,
    dataExport: 'Manual request',
    tracksUserData: true,
    communityActive: false
  },
  substack: {
    dataExport: 'CSV only',
    tracksUserData: true,
    complianceReady: false,
    projectAge: '2-5 years',
    communityActive: true,
    philosophies: ['transparent']
  },
  medium: {
    aiPowered: true,
    dataExport: 'Manual request',
    adSupported: true,
    tracksUserData: true,
    complianceReady: false,
    communityActive: false,
    philosophies: ['sustainability']
  },
  amazon: {
    aiPowered: true,
    dataExport: 'Manual request',
    adSupported: true,
    tracksUserData: true,
    complianceReady: false,
    communityActive: false
  },
  aliexpress: {
    aiPowered: true,
    dataExport: 'No export',
    adSupported: true,
    tracksUserData: true,
    complianceReady: false,
    communityActive: false
  },
  taobao: {
    aiPowered: true,
    dataExport: 'No export',
    adSupported: true,
    tracksUserData: true,
    complianceReady: false,
    communityActive: false
  },
  paypal: {
    aiPowered: true,
    dataExport: 'CSV only',
    tracksUserData: true,
    communityActive: false,
    philosophies: ['transparent']
  },
  codeberg: {
    dataExport: 'Markdown/Local',
    offlineMode: true,
    tracksUserData: false,
    projectAge: '0-2 years',
    communityActive: true,
    ossLicense: 'AGPL-3.0',
    philosophies: ['local-first', 'decentralised', 'transparent']
  }
};

const hasOwn = (object, key) => Object.prototype.hasOwnProperty.call(object, key);

export function enrichCatalog(entries = []) {
  return entries.map(entry => {
    const meta = catalogMetadata[entry.id] || {};
    const enriched = {
      ...entry,
      ...catalogFacetDefaults,
      ...meta
    };

    if (!hasOwn(meta, 'hasMobileApp')) {
      enriched.hasMobileApp = Array.isArray(entry.platforms)
        ? entry.platforms.some(platform => /ios|android/i.test(platform))
        : catalogFacetDefaults.hasMobileApp;
    }

    if (!hasOwn(meta, 'complianceReady')) {
      enriched.complianceReady = Array.isArray(entry.compliance) && entry.compliance.length > 0;
    }

    if (!hasOwn(meta, 'ossLicense')) {
      enriched.ossLicense = entry.isOpenSource ? 'Community OSS' : catalogFacetDefaults.ossLicense;
    }

    if (hasOwn(meta, 'philosophies')) {
      enriched.philosophies = [...meta.philosophies];
    } else {
      enriched.philosophies = [];
    }

    return enriched;
  });
}

export { catalogFacetDefaults, catalogMetadata };
